import axios from "axios";
import { API_BASE_URL } from "../Constants";

 const axiosInterceptor = axios.create({
  baseURL: API_BASE_URL,
   headers: {
    "Content-Type": "application/json",
  },
});

axiosInterceptor.interceptors.request.use(
  (config) => {
     // Do something before request is sent
    // Reading the token must not throw: with no stored token (or a corrupt one)
    // JSON.parse used to blow up here and the request never left the browser,
    // which surfaced as a screen that silently stayed empty.
    let token = null;
    try {
      const tokenString = localStorage.getItem('token');
      const userToken = tokenString ? JSON.parse(tokenString) : null;
      token = userToken ? userToken.token : null;
    } catch (e) {
      token = null;
    }
    if (token) {
     // config.headers.accessToken = token;
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
   function (error) {
      // Do something with request error
    return Promise.reject(error);
  }
);

axiosInterceptor.interceptors.response.use(
   function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
   function (error) {
    // An expired or rejected token used to be ignored here, so every screen
    // just came up empty with no hint that the session had ended. Send the
    // user back to the login page instead.
    const status = error && error.response ? error.response.status : null;
    if (status === 401 && window.location.pathname !== '/login') {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = '/login?expired=true';
    }
    return Promise.reject(error);
  }
);

export default axiosInterceptor;